import Carousel from "@/src/components/common/carousel";

import FacilitesList from "../facilities/facilitiesList";

const HomeFacilities = ({ facilities }) => {
    return (
        <div className="py-8">
            <div className="max-w-6xl mx-auto">
                <h2 className="md:text-left text-center md:text-2xl text-xl font-bold text-black md:mb-6 mb-2">
                    Facilities
                </h2>

                <Carousel
                    settings={{
                        speed: 700,
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        // centerMode: true,
                        responsive: [
                            {
                                breakpoint: 600,
                                settings: {
                                    slidesToShow: 1,
                                },
                            },
                        ],
                    }}
                >
                    {facilities?.length > 0 &&
                        facilities?.map((row) => (
                            <FacilitesList
                                key={row.categoryId}
                                row={row}
                                isSpacing={true}
                            />
                        ))}
                </Carousel>
            </div>
        </div>
    );
};

export default HomeFacilities;
